import React from 'react';
import { Typography } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';
import modules_51430e0a from './MenuItem.module.less.js';

const { Link } = Typography;
const MenuItem = ({ children, onClick, className }) => {
    const cx = useStyles(modules_51430e0a);
    return (React.createElement(Link, { target: "_self", className: cx('container', 'searchContainer', className), onClick: onClick }, children));
};

export { MenuItem };
//# sourceMappingURL=MenuItem.js.map
